import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import SwipeableViews from 'react-swipeable-views';
import {LoadMore} from 'react-weui';
import config from '../../config'
import '../../styles/classroom/ClassroomPPT.css';
import ppt_placeholder from '../../images/ppt_placeholder.jpg';


class ClassroomPPTSlide extends Component {
    constructor(props) {
        super(props);
        this.state = {
            index: props.selectedPPTIndex,
            loading: false,
        };
        this.handleSlideLeft = this.handleSlideLeft.bind(this)
        this.handleSlideRight = this.handleSlideRight.bind(this)
        this.handlePPTChange = this.handlePPTChange.bind(this)
        this.handleTouchStart = this.handleTouchStart.bind(this)
        this.handleTouchEnd = this.handleTouchEnd.bind(this)
        this.handleShowPPTImage = this.handleShowPPTImage.bind(this)
    }

    componentWillUpdate(nextProps, nextState) {
        let index = nextProps.selectedPPTIndex;

        if (index === this.state.index) {
            return;
        }

        if (nextProps.isSelectPPT) {
            this.setState({index});
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.isRefreshPPT) {
            this.props.dispatch({
                type: 'CLASSROOM_REFRESH_PPT_DONE'
            })
        }
    }

    componentDidMount() {
        let {lecture, options} = this.props;
        if (options.ppt_open) {
            this.setState({loading: true})
            // 读取ppt
            axios.get(`/api/classroom/${lecture.id}/ppt/list`).then((response) => {
                if (response.data.code === 0) {
                    this.props.dispatch({
                        type: 'CLASSROOM_SET_PPT',
                        ppts: response.data.data.ppts.map(v => {
                            v.loaded = false;
                            return v
                        })
                    });
                    this.setState({loading: false})
                }
                if (response.data.data.ppts.length) {
                    this.props.dispatch({
                        type: 'CLASSROOM_SET_SELECTED_PPT_INDEX',
                        selectedPPTIndex: 0,
                    })
                }
            });
        }
    }

    render() {
        let {index, loading} = this.state;
        let {pptAreaHeight, ppts, selectedPPTIndex, role, showTopVideo, isLectureBegin} = this.props;
        const clientWidth = Math.min(480, window.innerWidth || screen.width)
        const pptHeight = showTopVideo ? Math.ceil(clientWidth * 1080 / 1920) : 0

        if (loading && (role.is_lecturer || role.is_manager)) {
            return <div className="ppt-container" style={{height: pptHeight + 'px'}}>
                <div className="classroom-no-ppt-body">
                    <LoadMore loading/>
                </div>
            </div>
        }

        return (
            <div className="ppt-container" style={{display: showTopVideo ? 'block' : 'none'}}>
                {ppts.length > 0 ?
                    (!isLectureBegin && showTopVideo && !(role.is_lecturer || role.is_manager)) ?
                        <div className="ppt" style={{height: pptAreaHeight + 'px'}}>
                            <img src={ppts[0].medium_ppt_url}/>
                        </div>
                        :
                        <div onTouchStart={this.handleTouchStart} onTouchEnd={this.handleTouchEnd}>
                            <SwipeableViews ref="ppts"
                                            index={index}
                                            disableLazyLoading={false}
                                            ignoreNativeScroll={true}
                                            onChangeIndex={this.handlePPTChange}>
                                {ppts.map((item, index) => (
                                    <div className="ppt" key={item.id} style={{height: pptAreaHeight + 'px'}}
                                         data-url={item.ppt_url} onClick={this.handleShowPPTImage}>
                                        <img className="ppt-image"
                                             src={item.loaded ? item.medium_ppt_url : ppt_placeholder}
                                             data-id={item.id}/>
                                    </div>
                                ))}
                            </SwipeableViews>

                            <div className="ppt-text ppt-indicators">
                                <span>{selectedPPTIndex + 1}</span> / <span>{ppts.length}</span>
                            </div>

                            <a href="javascript:;" className="ppt-text ppt-operate-prev" onClick={this.handleSlideLeft}>
                                上一张 </a>
                            <a href="javascript:;" className="ppt-text ppt-operate-next"
                               onClick={this.handleSlideRight}>
                                下一张 </a>
                        </div>
                    :
                    role.is_lecturer &&
                    <div className="classroom-no-ppt" style={{height: pptHeight + 'px'}}>
                        <div className="classroom-no-ppt-body" style={{width:'200px'}}>
                            <p>尚未上传PPT</p>
                            <p style={{marginTop: '10px'}}>请点击底部<i
                                className="iconfont icon-xinbanketangye-gengduo menu-font"/>选择上传PPT</p>
                            <p style={{marginTop: '10px'}}>或登录讲师管理后台-课程管理操作上传</p>
                            {['ios', 'android'].indexOf(window.systemType) > -1 ?
                                <p>({config.ADMIN_BASE_URL}/lecture/)</p>
                                :
                                <p>(<a className="wk-link" href={config.ADMIN_BASE_URL+"/lecture/"}
                                       target="_blank">{config.ADMIN_BASE_URL}/lecture/</a>)
                                </p>
                            }
                        </div>
                    </div>
                }
            </div>
        )
    }

    handlePPTChange(index, indexLatest) {
        this.props.dispatch({
            type: 'CLASSROOM_SET_SELECTED_PPT_INDEX',
            selectedPPTIndex: index,
        });
    }

    handleSlideLeft(e) {
        if (this.state.index === 0) {
            this.context.page.showTips('已经是第一张PPT', 'primary');
            return
        }
        let newIndex = this.state.index - 1;
        this.setState({index: newIndex});
        this.handlePPTChange(newIndex);
        this.lecturerSelectPPT(newIndex);
    }

    handleSlideRight(e) {
        if (this.state.index === this.props.ppts.length - 1) {
            this.context.page.showTips('已经是最后一张PPT', 'primary');
            return
        }
        let newIndex = this.state.index + 1;
        this.setState({index: newIndex});
        this.handlePPTChange(newIndex);
        this.lecturerSelectPPT(newIndex);
    }

    lecturerSelectPPT(index) {
        if (this.props.role.is_lecturer && this.props.audioState !== 'playing') {
            let ppt = this.props.ppts[index];
            const url = `api/classroom/${this.props.lecture.id}/ppt/${ppt.id}/select`;
            axios.post(url);
        }
    }

    handleShowPPTImage(e) {
        let {ppts} = this.props;
        let urls = ppts.map((item) => {
            return item.ppt_url;
        });
        let currentPPTImage = e.target.dataset.url || e.currentTarget.dataset.url;
        if (window.wxReady) {
            window.wx.previewImage({
                current: currentPPTImage,
                urls: urls,
            });
        } else {
            window.open(currentPPTImage);
        }
    }

    handleTouchStart(e) {
        this.startX = e.touches[0].clientX
        this.startTime = new Date()
    }

    handleTouchEnd(e) {
        const duration = Math.abs(new Date() - this.startTime)
        const endX = e.changedTouches[0].clientX
        const dx = endX - this.startX
        const container = this.refs.ppts.containerNode
        const width = Math.round(container.getBoundingClientRect().width || container.offsetWidth);

        if ((duration < 250 && dx > 20) || dx >= width / 2) {
            this.handleSlideLeft();
        }

        if ((duration < 250 && dx < -20) || dx <= -(width / 2)) {
            this.handleSlideRight();
        }
    }
}

ClassroomPPTSlide.contextTypes = {
    page: React.PropTypes.object
};


export default connect((state) => ({
    account: state.account,
    lecture: state.classroom.lecture,
    options: state.classroom.options,
    pptAreaHeight: state.ppt.pptAreaHeight,
    ppts: state.ppt.ppts,
    operatePPT: state.ppt.operatePPT,
    selectedPPTIndex: state.ppt.selectedPPTIndex,
    selectedPPTId: state.ppt.selectedPPTId,
    isSelectPPT: state.ppt.isSelectPPT,
    isRefreshPPT: state.ppt.isRefreshPPT,
    role: state.classroom.role,
    showTopVideo: state.classroom.showTopVideo,
    audioState: state.audioPlayer.audioState,
}))(ClassroomPPTSlide)



// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomPPTSlide.js